<template>
  <section class="chapter6">
    <HetDal></HetDal>
    <div class="bottom">
      <Container>
        <Title>Uit het dal</Title>
        <Content>
          <p>Een depressie overwinnen is moeilijk en duurt vaak maanden. Gemiddeld wachten jongeren tien weken op professionele hulp. Daarna is het risico op een terugval groot. Met de zes dappere jongeren die hun verhaal met ons deelden gaat het nu wel een stuk beter. Hun verhalen verschillen, hieronder vertellen ze wat hen geholpen heeft op de weg naar herstel.</p>
        </Content>
      </Container>
      <DalSlider></DalSlider>
    </div>
  </section>
</template>

<script>
import { Title, Content, Container } from '@/components/chapter'
import { HetDal, DalSlider } from '@/components/dal'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Chapter6',
  mixins: [chapterMixin],
  components: {
    Title,
    Content,
    HetDal,
    DalSlider,
    Container
  }
}
</script>

<style lang="scss" scoped>
.chapter6 {
}
.bottom  {
  padding-top: 95px;
  padding-bottom: 85px;
  background-color: $c-light;
  position: relative;

  @media (min-width: 768px) {
    padding-top: 121px;
    padding-bottom: 129px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Chapter6.vue